'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
    this.one = {};
  }

  save() {
    this.$http.post(`/api/AppConfGroups`, this.one).then(res => {
      this.$state.go('^');
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/add/add.controller.js